module.exports = __webpack_public_path__ + "img/scc-03-flat.2e05ada6.png";